/**
 * Extended boolean type without data representing "True"
 */
export const VALUE_TRUE = true

/**
 * Extended boolean type without data representing "False"
 */
export const VALUE_FALSE = false

/**
 * Extended type without data representing "None"
 * @type {null}
 */
export const VALUE_NONE = null

/**
 * Extended type without data representing "Infinity"
 */
export const VALUE_INFINITY = Infinity
